/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleUpgradeChangeSummary } from './moduleUpgradeChangeSummary';

export type ModuleUpgradePreviewGroupChangeSummary = ModuleUpgradeChangeSummary | null;
